<div class="hx-donut-chart__layout">
  <!-- Donut Chart (40%) -->
  <div class="hx-donut-chart__ring-column">
    <div class="hx-donut-chart__ring" [ngClass]="sizeClass()">
      <svg
        viewBox="0 0 100 100"
        class="h-full w-full"
        role="img"
        [attr.aria-label]="'Donut chart with ' + segments().length + ' segments, total ' + totalValue()">
        <title>Donut chart, total {{ totalValue() }}</title>
        <!-- Rotated group for segments -->
        <g transform="rotate(-90 50 50)">
          <!-- Background circle -->
          <circle cx="50" cy="50" r="40" fill="none" [attr.stroke]="backgroundStroke()" stroke-width="12" />
          <!-- Segments -->
          @for (segment of renderedSegments(); track $index) {
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              [attr.stroke]="segment.color"
              stroke-width="12"
              [attr.stroke-dasharray]="segment.dashArray"
              [attr.stroke-dashoffset]="segment.dashOffset" />
          }
        </g>
        <!-- Total label inside ring -->
        @if (showTotal()) {
          <text
            x="50"
            y="44"
            text-anchor="middle"
            dominant-baseline="auto"
            fill="#6b7280"
            [attr.font-size]="totalLabelFontSize()"
            font-family="inherit">
            Total
          </text>
          <text
            x="50"
            y="62"
            text-anchor="middle"
            dominant-baseline="auto"
            fill="#111827"
            font-weight="700"
            [attr.font-size]="totalValueFontSize()"
            font-family="inherit">
            {{ totalValue() }}
          </text>
        }
      </svg>
    </div>
  </div>

  <!-- Legend (60%) -->
  @if (showLegend()) {
    <div class="hx-donut-chart__legend-column">
      @if (legendVariant() === 'split') {
        <div class="hx-donut-chart__split-panel">
          <div class="hx-donut-chart__split-row">
            @for (segment of segments(); track $index; let last = $last) {
              <div [ngClass]="legendItemClasses()">
                <div class="mb-1 flex items-center gap-2">
                  <hx-badge type="dot" [color]="segment.color" [ariaLabel]="segment.label"></hx-badge>
                  <span class="text-sm font-medium text-gray-600">{{ segment.label }}</span>
                </div>
                <div class="text-2xl font-bold">
                  {{ segment.value }}
                  <span class="text-base text-gray-500">({{ getPercentage(segment.value) }}%)</span>
                </div>
              </div>
              @if (!last) {
                <div class="hx-donut-chart__split-divider"></div>
              }
            }
          </div>
        </div>
      } @else {
        <div class="flex flex-nowrap items-center gap-4">
          @for (segment of segments(); track $index; let last = $last) {
            <div class="flex items-center gap-4">
              <div [ngClass]="legendItemClasses()">
                <div class="mb-1 flex items-center gap-2">
                  <hx-badge type="dot" [color]="segment.color" [ariaLabel]="segment.label"></hx-badge>
                  <span class="text-sm font-medium text-gray-600">{{ segment.label }}</span>
                </div>
                <div class="text-2xl font-bold">
                  {{ segment.value }}
                  <span class="text-base text-gray-500">({{ getPercentage(segment.value) }}%)</span>
                </div>
              </div>
              @if (!last) {
                <div class="h-16 w-px bg-gray-200"></div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
